import styled from "@emotion/styled";

import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import ToggleButton from "@mui/material/ToggleButton";

export const StyledButtonGroup = styled(ToggleButtonGroup)`
  display: flex;
  flex-wrap: wrap;

  .toggle-button-item {
    color: #97989e;
    padding: 5px 10px;
    border-radius: 10px !important;
    border: none;
    background-color: #f0f0f0;
    text-transform: none;
    margin-top: 2px;

    &.Mui-selected,
    :active,
    :hover {
      background-color: rgba(0, 0, 0, 0.9);
      color: white;
    }

    &:hover {
      background-color: rgba(0, 0, 0, 0.5);
      color: white;
    }

    &.Mui-selected:hover {
      background-color: rgba(0, 0, 0, 0.9);
      color: white;
    }

    &.has-data:not(.Mui-selected) {
      background-color: #e0f7fa;
      color: #00838f;
      border: 1px solid #00acc1;
    }

    &.has-data.Mui-selected {
      background-color: #00838f;
      color: white;
    }

    &.has-data:hover:not(.Mui-selected) {
      background-color: #b2ebf2;
      color: #00838f;
    }
  }
`;

export const StyledButton = styled(ToggleButton)<{ withDegree?: boolean }>`
  margin-right: ${({ withDegree }) => (withDegree ? "15px" : "4px")};

  ::after {
    content: ${({ withDegree }) => (withDegree ? "'°'" : "''")};
    position: absolute;
    background-color: #fff;
    color: black;
    top: -5px;
    right: -9px;
    cursor: default;
    pointer-events: none;
  }

  :hover::after,
  :active::after {
    background-color: #fff;
    color: black;
  }
`;
